import { useInfiniteQuery } from '@northladder/services';

import { IPaginationParams } from '../../types';

import { B2B_SERVICE_API } from '../b2bApiClient';
import { IQuoteRequestsListResponse } from '../types';

/**
 * Query key for enterprise recent customer quotes list caching.
 */
export const FETCH_ADMIN_QUOTES_REQUESTS_LIST_QUERY_KEY =
  'fetch-admin-quotes-requests-list-key';

/**
 * It returns the query for the mock enterprise quotes requests data.
 */
export const useAdminQuoteRequestsListQuery = ({ page }: IPaginationParams) =>
  useInfiniteQuery<IQuoteRequestsListResponse, Error>({
    queryKey: [FETCH_ADMIN_QUOTES_REQUESTS_LIST_QUERY_KEY, page],
    queryFn: async ({
      pageParam = page,
    }): Promise<IQuoteRequestsListResponse> => {
      const result = await B2B_SERVICE_API.fetchQuoteRequestsList({
        page: pageParam,
      });
      return result;
    },
    initialPageParam: 1,
    maxPages: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    getPreviousPageParam: (firstPage) => firstPage.previousPage,
  });
